var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-modal',{ref:"modal",attrs:{"scrollable":"","id":"barcode-modal","header-class":"headerModal","centered":"","title":"Barcode","hide-footer":"","hide-header":""}},[_c('canvas',{ref:"barcodeCanvas",staticStyle:{"width":"200px","height":"100px"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }